export class clientonboardBO {
  view = false;
  edit: boolean = false;
  onboardingId: string;
  documentid: any;
  datalist: any;
  clientID: string;
  add: boolean = false;
  statusinfo: string;
  onboardingStatusLovCode: string
  templateToOnboard = false;
  templateid: string;
  isCompleted: boolean = false;
}

///////////////////////////////// DOCUMENTLIST GETBO ///////////////////////////////
export class GetListBase {
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "status";
  orderType: string = "asc";
  type: string = "string";
  field: string = "status";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
  agencyId: string;
  id: string;
  statusLid: string;
  status: string;
  isCompleted: boolean;
  clientid: string;
  documentStatus: string = "00000000-0000-0000-0000-000000000000";
  completed: string = "00000000-0000-0000-0000-000000000000";
}

export class columnWidth {
  column: string = "";
  width: number = 0;
}























